<template lang="pug">
#modal-editar-camadas-vinculadas
    el-dialog(
        width='80%',
        title='Editar camadas vinculadas',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        main
            .modal-editar-camadas-vinculadas__desabilitadas
                h3.mb-3 Desabilitadas
                    BaseButton(
                        size='mini',
                        icon='el-icon-check',
                        @click='selecionarConfiguracaoVega'
                    ) Configuração Vega
                el-card(shadow='never', :body-style='{ padding: "10px" }')
                    el-table.box-card(
                        ref='tabelaDesabilitadas',
                        :data='camadasDesabilitadasFiltradas',
                        size='mini',
                        height='350px',
                        @selection-change='alterarCamadasDesabilitadasSelecionadas'
                    )
                        el-table-column(type='selection', width='50')
                        el-table-column(
                            label='Nome',
                            prop='nome',
                            sortable,
                            :min-width='100'
                        )
                        el-table-column(align='right')
                            template(slot='header', slot-scope='scope')
                                el-input(
                                    v-model='filtroCamadasDesabilitadas',
                                    size='mini',
                                    placeholder='Pesquisar'
                                )

                    footer.mt-2
                        span {{ camadasDesabilitadasSelecionadas.length }} {{ camadasDesabilitadasSelecionadas.length === 1 ? 'camada selecionada' : 'camadas selecionadas' }}

            el-button-group
                BaseButton(
                    type='primary',
                    icon='el-icon-arrow-left',
                    size='medium',
                    @click='desabilitarCamadas'
                )
                BaseButton(
                    type='primary',
                    icon='el-icon-arrow-right',
                    size='medium',
                    @click='habilitarCamadas'
                )

            .modal-editar-camadas-vinculadas__habilitadas
                h3.mb-3
                    | Habilitadas

                el-card(shadow='never', :body-style='{ padding: "10px" }')
                    el-table.box-card(
                        ref='tabelaHabilitadas',
                        :data='camadasHabilitadasFiltradas',
                        size='mini',
                        height='350px',
                        @selection-change='alterarCamadasHabilitadasSelecionadas'
                    )
                        el-table-column(type='selection', width='50')
                        el-table-column(
                            label='Nome',
                            prop='nome',
                            sortable,
                            :min-width='100'
                        )
                        el-table-column(align='right')
                            template(slot='header', slot-scope='scope')
                                el-input(
                                    v-model='filtroCamadasHabilitadas',
                                    size='mini',
                                    placeholder='Pesquisar'
                                )

                    footer.mt-2
                        span {{ camadasHabilitadasSelecionadas.length }} {{ camadasHabilitadasSelecionadas.length === 1 ? 'camada selecionada' : 'camadas selecionadas' }}

        footer(slot='footer')
            BaseButton(size='mini', @click='fechar') Cancelar
            BaseButton(size='mini', type='primary', @click='vincularCamadas') Confirmar
</template>

<script>
import { CamadasService } from '@/services/CamadasService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalEditarCamadasVinculadas',
    components: {
        BaseButton
    },
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },
        empresa: {
            type: Object,
            required: true
        },
        camadas: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            filtroCamadasDesabilitadas: '',
            filtroCamadasHabilitadas: '',
            camadasDesabilitadas: [],
            camadasHabilitadas: [],
            camadasDesabilitadasSelecionadas: [],
            camadasHabilitadasSelecionadas: []
        };
    },

    computed: {
        camadasDesabilitadasFiltradas() {
            return this.camadasDesabilitadas.filter(camada =>
                camada.nome
                    .toLowerCase()
                    .includes(this.filtroCamadasDesabilitadas.toLowerCase())
            );
        },

        camadasHabilitadasFiltradas() {
            return this.camadasHabilitadas.filter(camada =>
                camada.nome
                    .toLowerCase()
                    .includes(this.filtroCamadasHabilitadas.toLowerCase())
            );
        }
    },

    watch: {
        mostrar() {
            if (this.mostrar) {
                this.buscarCamadasHabilitadas();
            }
        }
    },

    methods: {
        async buscarCamadasHabilitadas() {
            const { data } = await CamadasService.buscarCamadasPorEmpresa(
                this.empresa.idEmpresa
            );
            this.camadasHabilitadas = data;

            const codigosCamadasHabilitadas = this.camadasHabilitadas.map(
                ({ codigo }) => codigo
            );

            this.camadasDesabilitadas = this.camadas.filter(
                ({ codigo }) => !codigosCamadasHabilitadas.includes(codigo)
            );
        },

        fechar() {
            this.filtroCamadasDesabilitadas = '';
            this.filtroCamadasHabilitadas = '';
            this.camadasDesabilitadasSelecionadas = [];
            this.camadasHabilitadasSelecionadas = [];

            this.limparSelecoes();

            this.$emit('fechar');
        },

        alterarCamadasDesabilitadasSelecionadas(linhas) {
            this.camadasDesabilitadasSelecionadas = linhas;
        },

        alterarCamadasHabilitadasSelecionadas(linhas) {
            this.camadasHabilitadasSelecionadas = linhas;
        },

        selecionarConfiguracaoVega() {
            CamadasService.buscarCamadasVega()
                .then(({ data }) => {
                    const camadasVega = data;

                    this.camadasDesabilitadasSelecionadas =
                        this.camadasDesabilitadas.filter(({ codigo }) =>
                            camadasVega.includes(codigo)
                        );

                    this.camadasDesabilitadasSelecionadas.forEach(camada =>
                        this.$refs.tabelaDesabilitadas.toggleRowSelection(camada)
                    );
            })
            .catch(() => {
                this.$notify.error({
                    message: `Ocorreu um erro ao buscar a configuração vega.`
                });
            });
        },

        limparSelecoes() {
            this.$refs.tabelaDesabilitadas.clearSelection();
            this.$refs.tabelaHabilitadas.clearSelection();
        },

        habilitarCamadas() {
            this.camadasHabilitadas = [
                ...this.camadasHabilitadas,
                ...this.camadasDesabilitadasSelecionadas
            ];

            const codigosCamadasHabilitadas = this.camadasHabilitadas.map(
                ({ codigo }) => codigo
            );

            this.camadasDesabilitadas = this.camadas.filter(
                ({ codigo }) => !codigosCamadasHabilitadas.includes(codigo)
            );

            this.limparSelecoes();
        },

        desabilitarCamadas() {
            this.camadasDesabilitadas = [
                ...this.camadasDesabilitadas,
                ...this.camadasHabilitadasSelecionadas
            ];

            const codigosCamadasDesabilitadas = this.camadasDesabilitadas.map(
                ({ codigo }) => codigo
            );

            this.camadasHabilitadas = this.camadas.filter(
                ({ codigo }) => !codigosCamadasDesabilitadas.includes(codigo)
            );

            this.limparSelecoes();
        },

        async vincularCamadas() {
            const idsCamadas = this.camadasHabilitadas.map(({ id }) => id);
            try {
                await CamadasService.vincularCamadasEmpresa(
                    this.empresa.idEmpresa,
                    idsCamadas
                );
                this.$emit('atualizar-tabela');
                this.$notify.success({ message: 'Camadas vinculadas' });
                this.fechar();
            } catch (error) {
                this.$notify.error({
                    message: 'Ocorreu um erro ao vincular as camadas à empresa'
                });
            }
        }
    }
};
</script>
<style lang="scss">
#modal-editar-camadas-vinculadas {
    main {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 16px;

        footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }

    footer {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
    }

    .modal-editar-camadas-vinculadas__desabilitadas,
    .modal-editar-camadas-vinculadas__habilitadas {
        width: 40%;

        h3 {
            display: flex;
            font-size: 16px;
            justify-content: space-between;
            align-items: center;
            height: 28px;
        }
    }
}
</style>
